import BusinessPartnerDistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-dchain/business-partners-dchain.entity';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import OrderAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity';
import { ICreateOrderDelivery } from './interfaces/create-business-partner-order.interface';
import orderDeliveryWindowsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity';
import SubRouteAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route.entity';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import { Subject, take, takeUntil } from 'rxjs';
import { SubRouteService } from 'app/modules/components/routing/sub-routes/sub-route.service';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@Component({
  selector: 'app-add-business-partner-order-modal',
  styleUrl: './business-partner-order.component.scss',
  templateUrl: './business-partner-order.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule
  ],
})
export class AddBusinessPartnerOrderComponent {
  getCode = getCode;
  currentCreateBusinessPartnerOrder: ICreateOrderDelivery = this.initializeCreateBusinessPartnerOrder();
  currentUpdateBusinessPartnerOrder: orderDeliveryWindowsAttributes | undefined;

  daysList: { day: string; value: number }[] = [
    { day: 'Lunes', value: 1 },
    { day: 'Martes', value: 2 },
    { day: 'Miércoles', value: 3 },
    { day: 'Jueves', value: 4 },
    { day: 'Viernes', value: 5 },
    { day: 'Sábado', value: 6 },
    { day: 'Domingo', value: 7 }
  ];
 isEditMode : boolean;
routeList: SubRouteAttributes[] = [];
  /** control for the selected masterUser for multi-selection */
   public routeMultiCtrl: FormControl<any[]> =
     new FormControl<any[]>([]);
 
   public routeMultiFilterCtrl: FormControl<string> =
     new FormControl<string>("");
 
   /** list of routeArea filtered by search keyword */
   public filteredRoute: ReplaySubject<SubRouteAttributes[]> =
     new ReplaySubject<SubRouteAttributes[]>(1);
 
   /** local copy of filtered routeArea to help set the toggle all checkbox state */
   protected filteredRouteCache: SubRouteAttributes[] = [];
    protected _onDestroy = new Subject<void>();
  constructor(
    public dialogRef: MatDialogRef<AddBusinessPartnerOrderComponent>,
    private subRouteService: SubRouteService,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {
    this.isEditMode = !!data;
    if (this.isEditMode) {
      this.currentCreateBusinessPartnerOrder = { 
        ...data,
        applyToAllSubRoutes: data.applyToAllSubRoutes ?? true,
        applyToTheseSubRouteIds: data.applyToTheseSubRouteIds,
    }; 
    }
  }

  
  ngAfterViewInit(): void {
    this.fetchRoute();
    // this.setupPaginationAndSorting();
    // this.findAllWithCount();
  }

    private fetchRoute(): void {
      this.subRouteService.findToComboBoxByModel("08").subscribe((res) => {
        this.routeList = res.data;
        this.filteredRoute.next(this.routeList);

        
        this.filteredRoute.pipe(take(1)).subscribe((routes) => {
          const selectedMaterials = routes.filter((route) =>
            this.currentCreateBusinessPartnerOrder?.applyToTheseSubRouteIds
              .map((r) => r)
              .includes(route._id.toString())
          );
          this.routeMultiCtrl.setValue(selectedMaterials.map(route => route._id));
        });

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteGroupMulti();
          });
      });
    }
  
    protected filterRouteGroupMulti() {
      if (!this.routeList) {
        return;
      }
      // get the search keyword
      let search = this.routeMultiFilterCtrl.value;
      if (!search) {
        this.filteredRouteCache = this.routeList;
        this.filteredRoute.next(this.routeList);
        return;
      } else {
        search = search.toLowerCase();
      }
      // Filtrar las rutas por nombre o código
      this.filteredRouteCache = this.routeList.filter((material) => {
        const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
        const codeMatches =
          material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
        return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
      });
      this.filteredRoute.next(this.filteredRouteCache);
    }

  private initializeCreateBusinessPartnerOrder(): ICreateOrderDelivery {
    return {
        days: [],
        hourStart: "",
        hourEnd: "",
        minutesStart: 0,
        minutesEnd: 0,
        numberOfHoursToDelivery:0,
        applyToAllSubRoutes: true,
        applyToTheseSubRouteIds: []
    };
  }

  onToggleApplyToAllRoutes() {
    if (this.currentCreateBusinessPartnerOrder.applyToAllSubRoutes) {
      this.routeMultiCtrl.reset(); 
      this.routeMultiCtrl.disable(); 
    } else {
      this.routeMultiCtrl.enable(); 
    }
  }
  save() {
    if (this.routeMultiCtrl.value && this.routeMultiCtrl.value.length > 0) {
      this.currentCreateBusinessPartnerOrder.applyToTheseSubRouteIds = this.routeMultiCtrl.value;
    }
    const dataToSend = Object.entries(this.currentCreateBusinessPartnerOrder)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}
